(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-mobile"] && !Shopify.designMode) return;
  try {
    class MediaGalleryMobile extends HTMLElement {
    constructor() {
      super();
      this.carousel = this.querySelector('.gallery-mob__carousel');
      this.slides = this.querySelectorAll('.gallery-mob__slide');
      this.dots = this.querySelectorAll('.gallery-mob__dot');
      this.thumbs = this.querySelectorAll('.gallery-mob__thumb');
      this.thumbsList = this.querySelector('.gallery-mob__thumbs-list');
      this.currentIndex = 0;
      this._programmaticTarget = null;
    }

    connectedCallback() {
      if (!this.carousel) return;

      this.carousel.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      this.carousel.addEventListener('pointerdown', () => {
        this._programmaticTarget = null;
      }, { passive: true });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.dotIndex, 10) - 1;
          this.goToSlide(idx);
        });
      });

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const idx = parseInt(thumb.dataset.thumbIndex, 10) - 1;
          this.goToSlide(idx);
        });
      });

      this.updateDots();
      this.updateThumbs();
      this.updateSlides();
    }

    onScroll() {
      if (this._scrollTimeout) cancelAnimationFrame(this._scrollTimeout);
      this._scrollTimeout = requestAnimationFrame(() => {
        const scrollLeft = this.carousel.scrollLeft;
        const slideWidth = this.carousel.offsetWidth || 1;
        const newIndex = Math.round(scrollLeft / slideWidth);

        if (this._programmaticTarget != null && newIndex !== this._programmaticTarget) {
          return;
        }
        if (this._programmaticTarget != null && newIndex === this._programmaticTarget) {
          this._programmaticTarget = null;
        }

        if (newIndex !== this.currentIndex) {
          this.currentIndex = newIndex;
          this.updateDots();
          this.updateThumbs();
          this.updateSlides();
        }
      });
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;

      this._programmaticTarget = index;
      this.currentIndex = index;
      this.updateDots();
      this.updateThumbs();
      this.updateSlides();

      const slideWidth = this.carousel.offsetWidth;
      this.carousel.scrollTo({ left: slideWidth * index, behavior: 'smooth' });

      const clearProgrammatic = () => {
        this._programmaticTarget = null;
        this.carousel.removeEventListener('scrollend', clearProgrammatic);
      };
      this.carousel.addEventListener('scrollend', clearProgrammatic, { once: true });
      clearTimeout(this._scrollSettleTimer);
      this._scrollSettleTimer = setTimeout(clearProgrammatic, 500);
    }

    updateDots() {
      this.dots.forEach((dot, i) => {
        const isActive = i === this.currentIndex;
        dot.classList.toggle('active', isActive);
        dot.classList.toggle('is-active', isActive);
      });
    }

    updateSlides() {
      this.slides.forEach((slide, i) => {
        const isActive = i === this.currentIndex;
        slide.classList.toggle('active', isActive);
        slide.classList.toggle('is-active', isActive);
        if (isActive) return;

        slide.querySelectorAll('video').forEach((video) => video.pause());
        slide.querySelectorAll('.js-youtube').forEach((iframe) => {
          iframe.contentWindow?.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          );
        });
        slide.querySelectorAll('.js-vimeo').forEach((iframe) => {
          iframe.contentWindow?.postMessage('{"method":"pause"}', '*');
        });
      });
    }

    updateThumbs() {
      if (!this.thumbs.length) return;

      this.thumbs.forEach((thumb, i) => {
        const item = thumb.closest('.gallery-mob__thumbs-item');
        const isActive = i === this.currentIndex;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
        if (item) item.classList.toggle('is-active', isActive);
      });

      const activeThumb = this.thumbs[this.currentIndex];
      if (!activeThumb || !this.thumbsList) return;

      const listRect = this.thumbsList.getBoundingClientRect();
      const thumbRect = activeThumb.getBoundingClientRect();
      const edge = 2;

      if (thumbRect.left < listRect.left + edge) {
        this.thumbsList.scrollBy({ left: thumbRect.left - listRect.left - edge, behavior: 'smooth' });
      } else if (thumbRect.right > listRect.right - edge) {
        this.thumbsList.scrollBy({ left: thumbRect.right - listRect.right + edge, behavior: 'smooth' });
      }
    }
  }

  if (!customElements.get('media-gallery-mobile')) {
    customElements.define('media-gallery-mobile', MediaGalleryMobile);
  }
  } catch(e) { console.error(e); }
})();

})();
